import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles, HighlightTypeEnum } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const prof: Partial<CaptionStyles> = {
  theme_preset: 'prof',
  pageStyle: {
    color: '#ffffff',
    background: '#1a5dfb',
    borderRadius: '16px',
    paddingLeft: '16px',
    paddingRight: '16px'
  },
  wordStyle: {
    highlightType: HighlightTypeEnum.None
  },
  letterStyle: undefined,
  font_location: getFontFullPath('Inter-Medium.ttf'),
  caps: false,
  line_config: CaptionLineConfig.TwoLines,
  font_size: 72,
  transitions: {
    wordIn: TransitionInEffect.Fade
  }
};

export default prof;
